__turbopack_context__.v({
  "AltText": "markdown-extended-module__MhyGfG__AltText",
  "ImageWrapper": "markdown-extended-module__MhyGfG__ImageWrapper",
});
